import {observer} from "mobx-react";
import {Component} from "preact";
import {alertStore} from "../model/alert";
import {Button} from "./controls/Button";
import {Dialog, DialogAlignment, DialogContent, DialogTitle} from "./controls/Dialog";

export const AlertDialog = observer(
	class AlertDialog extends Component {
		render() {
			return (
				<Dialog open={alertStore.open} alignment={DialogAlignment.CenterAutoWidth}>
					<DialogContent>
						{alertStore.title && <DialogTitle>{alertStore.title}</DialogTitle>}
						<p>{alertStore.message}</p>
						<Button primary onClick={this.handleOkayClick}>
							OK
						</Button>
					</DialogContent>
				</Dialog>
			);
		}

		private handleOkayClick = () => alertStore.open = false;
	},
);
